import { t } from "../i18n"
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String, attachmentId: Number }

  remove(event) {
    event.preventDefault()

    if (!confirm(t('javascript.controllers.attachment_removal_controller.confirm_remove'))) {
      return
    }

    const token = document.querySelector('meta[name="csrf-token"]').getAttribute('content')

    fetch(this.urlValue, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': token,
        'Accept': 'application/json'
      }
    }).then(async (response) => {
      if (response.ok) {
        const data = await response.json()
        // remove the attachment node from the DOM
        this.element.closest('.attachment-item')?.remove()
        // show a transient flash message
        this.showFlash(data.message || t('javascript.controllers.attachment_removal_controller.attachment_removed'))
      } else {
        const data = await response.json().catch(() => ({}))
        alert(data.message || t('javascript.controllers.attachment_removal_controller.failed_to_remove_attachment'))
      }
    }).catch((err) => {
      console.error('Remove attachment failed', err)
      alert(t('javascript.controllers.attachment_removal_controller.failed_to_remove_attachment'))
    })
  }

  showFlash(message) {
    let flash = document.getElementById('ajax-flash')
    if (!flash) {
      flash = document.createElement('div')
      flash.id = 'ajax-flash'
      flash.className = 'alert alert-success'
      flash.style.position = 'fixed'
      flash.style.top = '1rem'
      flash.style.right = '1rem'
      flash.style.zIndex = 9999
      document.body.appendChild(flash)
    }
    flash.textContent = message
    flash.style.display = 'block'

    setTimeout(() => {
      flash.style.display = 'none'
    }, 4000)
  }
}

